import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const timerUiNodeSpec: UiNodeSpec<'timer'> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'start', 'initialValue' ],
    }),
    cfg: () => ({ controlValues: { dir: 'down', limit: 0 }, id: getUID(), kind: 'timer', disabled: false }),
    controls: getNodeCfg => ({
        dir: {
            cfg: {
                items: [
                    { label: 'Count Up', value: 'up' },
                    { label: 'Count Down', value: 'down' },
                ],
                kind: 'selection',
                label: 'Mode',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.dir,
        },
        limit: { cfg: { kind: 'number', label: 'Limit', min: 0 }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.limit },
    }),
    inputs: nodeCfg => ({
        start: { socket: 'event', label: 'Start' },
        stop: { socket: 'event', label: 'Stop' },
        reset: { socket: 'event', label: 'Reset' },
        initialValue: {
            control: {
                cfg: { kind: 'number', nullable: true },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.initialValue,
            },
            socket: 'number',
            label: 'Initial Value',
        },
    }),
    kindLabel: 'Timer',
    nodeCategory: 'timeAndDate',
    outputs: () => ({
        done: { socket: 'event', label: 'Done' },
        tick: { socket: 'event', label: 'Tick' },
        value: { socket: 'number', label: 'Value' },
    }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (node.controlValues.limit < 0) {
            errors.limit = 'Limit must be at least 0';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
